import { ReportProblemRounded } from '@mui/icons-material/';
import { Box } from '@mui/material';

type Props = {
  symbolColor?: string;
  size?: string;
};

export const WarningIcon = ({
  symbolColor = '#fff',
  size = '1.8rem',
}: Props) => {
  return (
    <Box position="relative" fontSize={size} fontWeight="normal">
      <Box
        sx={{
          backgroundColor: symbolColor,
          position: 'absolute',
          width: '20%',
          height: '38%',
          top: '41%',
          left: 'calc(50% - 10%)',
        }}
      />
      <ReportProblemRounded
        color="error"
        sx={{ position: 'relative', fontSize: 'inherit', fontWeight: 'normal' }}
      />
    </Box>
  );
};
